import {kPlayStoreLink} from "../../../constants/links";
import {kSystemImages} from "../../../constants/images";

export default function HomePlayStoreButton() {
    // Used in MobileRedirectScreen to display a clickable Play Store
    // link

    // BUILD
    return (
        <a href={kPlayStoreLink}
           target="_blank"
           rel="noopener noreferrer">
            <div className={"flex h-[48px] items-center justify-center transition-all duration-150 hover:drop-shadow-[0_0_8px_rgba(255,255,255,0.4)]"}>
                <img className={"object-contain h-full"}
                     src={kSystemImages.getIsOnPlayStore}
                     alt="Disponible sur le Play store" />
            </div>
        </a>
    );
}